// extracted by mini-css-extract-plugin
export var active = "_g1-7";
export var blink = "_g1-8";
export var dropDownSelector = "_g1-4";
export var dropDownWrapper = "_g1-3";
export var fakeCursor = "_g1-6";
export var fontSizeButton = "_g1-9";
export var formQuillEditor = "_g1-0";
export var pressed = "_g1-a";
export var qlBlank = "_g1-1";
export var textFormattingToolbar = "_g1-2";
export var textToolbarOption = "_g1-5";